import { FC } from 'react';

import { Footer } from '@telialt/common-footer/src';

import { useFooterData } from '../hooks/useFooterData';
import { FooterDataResponse } from '../model';

type Props = {
    path: string;
};

export const FooterWithData: FC<Props> = ({ path }) => {
    const { data } = useFooterData(path);

    const navigationData = data as FooterDataResponse;

    return (
        <Footer
            socialMenu={navigationData?.footerSocialMenu}
            mainMenu={navigationData?.footerMainMenu}
            additionalMenu={navigationData?.footerAdditionalMenu}
            copyrightText={navigationData?.copyrightText}
        />
    );
};
